import QuestionChatDispute from "./QuestionChatDispute"
import masks from '../../../../helpers/utils/masks';
import Card from '../../../../components/bootstrap/Card';
import React, { useContext, useEffect, useState } from 'react';
import api from '../../../../services/api';
import axios from "axios";
import { DefaultContext } from "../../../../contexts/default";
import PreAlert from "../../../../helpers/utils/preAlert";

const ChatDispute = ({ data, selectedCard, maxAmount, ifoodToken, setSelectedCard }) => {
    const { storeInfo, onShowAlert } = useContext(DefaultContext);
    const [optionSelected, setOptionSelected] = useState('');
    const [otherValue, setOtherValue] = useState(null);
    const [declineReason, setDeclineReason] = useState('');
    const [images, setImages] = useState([]);

    useEffect(() => {
        setImages([])
        const fetchImages = async () => {
            if (!selectedCard?.disputeData?.evidences) return;

            const urls = await Promise.all(
                selectedCard.disputeData.evidences.map(async (e) => {
                    return await getImage(e.url);
                })
            );

            setImages(urls.filter(Boolean));
        };

        fetchImages();
    }, [selectedCard, ifoodToken]);

    const getImage = async (url) => {
        try {
            const res = await axios.get(url, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer ${ifoodToken}`,
                },
            });

            return URL.createObjectURL(res.data);
        } catch (error) {
            console.error("Erro ao buscar imagem:", error);
            return null;
        }
    };

    const getTextDisputa = () => {
        if (selectedCard.disputeData.status === "EXPIRED") {
            return 'Sua mensagem foi expirada por falta de resposta.'

        }
    }
    const handleSendMessage = async () => {
        if (!optionSelected) return;
        if (optionSelected === 'accepted') {
            await handleAcceptDispute();
        } else if (optionSelected === 'recusar') {
            await handleDeclineDispute();

        } else if (optionSelected === 'negociation') {
            await handleNegotiateDispute();

        }
        setOptionSelected('');
        setOtherValue(null);
        setDeclineReason('');
    };

    const handleAcceptDispute = async () => {
        if (!selectedCard) return;

        try {
            await api.post('/routesIfood/acceptDispute', {
                orderId: selectedCard.orderId,
                disputeId: selectedCard.disputeData.disputeId,
                storeInfo
            });
            setSelectedCard(null)
            onShowAlert(PreAlert.success('Disputa aceita com sucesso!'));
        } catch (error) {
            console.error(error);
            onShowAlert(PreAlert.error('Falha ao aceitar disputa.'));

        }
    };

    const handleDeclineDispute = async () => {
        if (!selectedCard) return;

        try {
            await api.post('/routesIfood/declineDispute', {
                orderId: selectedCard.orderId,
                disputeId: selectedCard.disputeData.disputeId,
                reason: declineReason,
                storeInfo
            });
            setSelectedCard(null)

            onShowAlert(PreAlert.success('Disputa recusada com sucesso!'));
        } catch (error) {
            console.error(error);
            onShowAlert(PreAlert.error('Falha ao recusar disputa.'));
        }
    };

    const handleNegotiateDispute = async () => {
        if (!selectedCard || !otherValue) return;

        try {
            const { id, type, currency } = selectedCard.disputeData.alternatives[0];
            await api.post('/routesIfood/negotiateDispute', {
                orderId: selectedCard.orderId,
                disputeId: selectedCard.disputeData.disputeId,
                alternativeId: id,
                data: {
                    type,
                    value: String(otherValue).replace(/\D/g, ''),
                    currency: 'BRL',
                },
                storeInfo
            });
            setSelectedCard(null)
            onShowAlert(PreAlert.success('Negociação enviada com sucesso!'));
        } catch (error) {
            console.error(error);
            onShowAlert(PreAlert.error('Falha ao negociar disputa.'));
        }
    };
    return (
        <>
            <div>

                {data?.itemsDispute && data?.itemsDispute?.length > 0 && (
                    <div style={{ marginTop: ".5rem" }}>
                        <Card
                            style={{
                                width: 'fit-content',
                                heigth: '80%',
                                marginBottom: '1rem',
                                marginRight: '8px',
                                padding: '8px 20px',
                            }}>
                            <h6><strong>Solicitação de reembolso dos itens:</strong></h6>
                        </Card>
                        <Card style={{ padding: '15px', width: 'fit-content' }}>
                            <div
                             style={{
                                position: 'relative',
                                overflow: 'auto',
                                whiteSpace: 'nowrap',
                                padding: '10px'
                             }}
                            
                            >
                                {images.length > 0 &&
                                    images.map((src, index) => (
                                        <img key={index} src={src} alt="Evidência"
                                            style={{
                                                width: "65px",
                                                height: "80px",
                                                marginRight: "8px",
                                                padding: 5,
                                                paddingBottom: 15
                                            }} />
                                    ))}
                            </div>
                            {data?.itemsDispute?.map((item) => (
                                <div key={item.id} style={{
                                    display: "flex",
                                    alignItems: "center",
                                    color: 'black'
                                }}>
                                    <div>
                                        <p>
                                            <strong> Item não entregue:</strong>
                                        </p>
                                        <p style={{ color: 'black' }}>{`${item.qtd}x - ${item.name}`}</p>
                                        <p style={{ color: 'black' }}>{item.reason}</p>
                                        <p style={{ color: 'black' }}>
                                            {item.total
                                                ? `R$ ${masks.money(
                                                    String(item.total),
                                                )}`
                                                : '-'}
                                        </p>
                                    </div>
                                </div>
                            ))}
                        </Card>
                    </div>
                )}

            </div>

            {selectedCard.disputeData.status ? (<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <Card style={{
                    backgroundColor: '#ffff',
                    color: 'black',
                    padding: '10px',                  
                    borderRadius: '10px',
                    marginBottom: '10px',
                    maxWidth: '60%',
                    alignSelf: 'flex-start',
                }}>
                    {selectedCard.disputeData.status === "EXPIRED"
                        ? getTextDisputa()
                        : selectedCard?.disputeData.reason}
                </Card>

            </div>) :
             <div
             style={{
                marginTop: "10px"
             }}
             >
                <QuestionChatDispute
                    data={data}
                    setOptionSelected={setOptionSelected}
                    optionSelected={optionSelected}
                    selectedCard={selectedCard}
                    maxAmount={maxAmount}
                    setOtherValue={setOtherValue}
                    otherValue={otherValue}
                    setDeclineReason={setDeclineReason}
                    declineReason={declineReason}
                    handleSendMessage={handleSendMessage}
                />

            </div>}

        </>

    )
}

export default ChatDispute